import React from 'react';
import { style, classes } from 'typestyle';
import { MarkDef } from '@src/types/Mark';

interface Props<T> {
  markDef: MarkDef<T>
  highlight?: string
  onClick?: (mark: MarkDef<T>) => void
  classes?: string[]
  suggestColor?: string
  iconSize?: number
}

export function Mark<T>({
  markDef,
  highlight,
  onClick,
  classes: clss = [],
  suggestColor,
}: Props<T>) {
  function renderText(text: string, hl?: string) {
    if (!hl) {
      return <span className={alignClass}>{text}</span>;
    }
    const suggested = text.slice(hl.length);
    return (
      <span className={alignClass}>
        <span>{hl}</span>
        <span
          style={{ color: suggestColor || 'gray' }}
        >
          {suggested}
        </span>
      </span>
    );
  }

  return (
    <div
      className={classes(markClass, ...clss)}
      onClick={() => onClick && onClick(markDef)}
      title={markDef.text}
    >
      <span className={classes(alignClass, symbolClass)}>
        <markDef.symbol style={{ fontSize: 12 }} />
      </span>
      {renderText(markDef.text, highlight)}
    </div>
  );
}

const markClass = style({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: 14,
});

const symbolClass = style({
  marginRight: 6,
});

const alignClass = style({
  verticalAlign: 'middle',
});
